import { useParams } from 'react-router-dom'
import { useFilterOnConsolidateAgreement } from '../../hooks/useFilterOnConsolidateAgreement'
import { useChosenCompany } from '../../../../context/UserProvider'
import { useQuery } from 'react-query'
import { fetchPurhcaseReportDetails } from '../../../../api/api'
import PurchaseReportDetailsTable from '../components/PurchaseTables/PurchaseReportDetailsTable'
import { ExcelExportButton } from '../components/ExcelExporter'
import { ConsolidateInvoiceSelect } from '../../../cars/components/V3/_shared/ConsolidateInvoiceSelect'
import { excelPurchaseReportDetailsColumns } from '../components/PurchaseTables/excelUtils'
import type { PurchaseReportDetails as PurchaseDetails } from '../../../../types'

const PurchaseReportDetails = () => {
  const company = useChosenCompany()
  const companyId = company?.id
  const { date } = useParams()
  const agreementFilter = useFilterOnConsolidateAgreement()

  const [year, month] = date ? date.split('-') : ['', '']

  const { data: response, isLoading } = useQuery(
    ['purchaseReportDetails', companyId, year, month],
    () => fetchPurhcaseReportDetails(company.id, year, month),
    { enabled: !!companyId },
  )

  const data = (
    Array.isArray(response) ? response : response && 'data' in response ? response.data : []
  ) as PurchaseDetails[]

  const filteredData = data.filter(agreementFilter('consolidatedInvoiceAgreement'))
  const columns = excelPurchaseReportDetailsColumns()
  const config = {
    columns,
    filename: `Kjøpsrapport_Detaljert__${year}_${month}.xlsx`,
    sheetName: `Kjøpsrapport_Detaljert__${year}_${month}`,
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col md:flex-row md:items-center gap-2 md:justify-between">
        <div className="flex flex-row justify-between ">
          <div className="flex flex-col md:items-center md:flex-row gap-2">
            <span className="text-xl font-medium text-primaryText">Detaljert kjøpsrapport</span>
            <span className=" hidden md:block text-lg text-secondaryText">/</span>
            <span className="text-lg text-secondaryText">
              {year}-{month}
            </span>
          </div>
          <div className="md:hidden">
            <ExcelExportButton data={filteredData} config={config} />
          </div>
        </div>
        <div className="flex flex-row gap-2 w-full md:w-auto">
          <div className="flex-1 md:flex-none">
            <ConsolidateInvoiceSelect className="h-11 w-full" />
          </div>
          <div className="hidden md:block">
            <ExcelExportButton data={filteredData} config={config} />
          </div>
        </div>
      </div>
      <PurchaseReportDetailsTable isLoading={isLoading} options={{ year, month }} data={filteredData} />
    </div>
  )
}

export default PurchaseReportDetails
